const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the user limits component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('userLimits', ['Authorization', 'Users', '$translate', '$timeout', function (Authorization, Users, $translate, $timeout) {
  return {
    restrict: 'E',
    scope: {
      tabWatch: '='
    },
    replace: true,
    template: require('../../templates/directives/user-limits.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.initialized = false;
      self.translations = {};
      self.authtoken = Authorization.getAuthToken();
      self.user = self.authtoken.user;
      self.loadedEmail = self.user.email;

      self.seats = {
        purchased: 0,
        used: 0,
        percent: 0,
        admins: 0,
        suspended: 0,
        external: 0,
        atMax: false,
        maxModal: false,
        renew: 'March 28, 2440'
      };

      self.chartConfig = {
        data: [50,50],
        customlabels: [ self.translations['userLimits.availableSeats'], self.translations['userLimits.usedSeats'] ],
        hidepercent: true
      };

      self.modals = {
        addSeats: false
      };

      self.submitAddSeatsHandler = function(e){
        var elms = {
          'success': document.querySelector('.js-successMessage'),
          'error': document.querySelector('.js-errorMessage'),
          'input': document.querySelector('#mce-SEATS'),
          'form': document.querySelector('#mc_embed_signup'),
          'header': document.querySelector('.js-header')
        };
        elms.success.style.display = 'none';
        elms.error.style.display = 'none';
        if(elms.input.value.length && self.user.email.length){
          elms.success.style.display = 'block';
          elms.form.style.display = 'none';
          elms.header.innerHTML = '';
          var resetSeat = function(){
            self.modals.addSeats = false;
            elms.success.style.display = 'none';
            elms.form.style.display = 'block';
            elms.input.value = '';
            elms.header.innerHTML = 'How many do you need?';
          };
          $timeout(resetSeat, 4000);
        } else {
          e.preventDefault();
          elms.error.style.display = 'block';
        }
      };

      self.initialize = function() {
        self.initialized = true;
        Users.companySeats().$promise
        .then(function(data) {
          self.seats.purchased = data.purchased && parseInt(data.purchased) || 0;
          self.seats.used = data.used && parseInt(data.used) || 0;
          self.seats.admins = data.admin && parseInt(data.admin) || 0;
          self.seats.external = data.external && parseInt(data.external) || 0;
          self.seats.active = data.active && parseInt(data.active) || 0;
          self.seats.suspended = data.suspended && parseInt(data.suspended) || 0;
          self.seats.inactive = self.seats.purchased - self.seats.used;
          self.chartConfig.data[1] = self.seats.used;
          self.chartConfig.data[0] = self.seats.inactive < 0 ? 0 : self.seats.inactive;
          if (self.seats.purchased && self.seats.purchased > self.seats.used) {
            self.seats.percent = self.seats.used / self.seats.purchased * 100;
            return;
          }
          if (self.seats.purchased && self.seats.purchased <= self.seats.used) {
            self.seats.percent = 100;
            self.seats.atMax = true;
            self.seats.maxModal = true;
            return;
          };
        }).catch(function(error) {
          console.log('error: ', error)
        });



      };

      $translate([
        'userLimits.availableSeats',
        'userLimits.usedSeats'
      ]).then(function(translations){
        self.translations = translations;
        self.chartConfig.customlabels = [self.translations['userLimits.availableSeats'],self.translations['userLimits.usedSeats']];
        if ($scope.tabWatch === 'seats') {
          self.initialize();
          return;
        }
        var initWatch = $scope.$watch(function(newVal, oldVal) {
          if ($scope.tabWatch === 'seats' && !self.initialized) {
            self.initialize();
            initWatch();
          }
        });
      });

    }],
    controllerAs: 'limits'
  };
}]);
